import { createUser } from "@/business/users/application/createUser";
import { editUser } from "@/business/users/application/editUser";
import { getAllUsers } from "@/business/users/application/getAllUsers";
import { removeUser } from "@/business/users/application/removeUser";
import { Role, User, UserActions } from "@/business/users/domain/user";
import { ref, Ref, onMounted } from "vue";
import { SelectOption } from "@/business/shared/commons/selectOption";
import { getRoles } from "@/business/users/application/getRoles";
import { encrypt } from "@/business/shared/commons/encrypt/encryptService";

export function usersUse() {
  const modalInfoUser: Ref<boolean> = ref(false);
  const users: Ref<User[]> = ref([]);
  const userSelected: Ref<User | null> = ref(null);
  const roles: Ref<SelectOption[]> = ref([]);

  onMounted(async () => {
    users.value = await getAllUsers.execute();
    roles.value = await getRoles.execute();
  });

  function createNewUser() {
    userSelected.value = null;
    modalInfoUser.value = true;
  }

  function editUserSelected(user: User) {
    modalInfoUser.value = true;
    userSelected.value = user;
  }

  function closeInformationUserModal() {
    modalInfoUser.value = false;
    userSelected.value = null;
  }

  async function createUserOperation(
    name: string,
    username: string,
    role: string,
    emplid: string,
    base_price: string,
    password: string,
    email: string
  ) {
    const rol = await getRoleFromId(role);
    if (rol !== null) {
      const encryptPassword = await encrypt(password);
      const newUser = await createUser.execute(
        name,
        username,
        role,
        emplid,
        base_price,
        encryptPassword,
        email,
        rol
      );
      users.value.push(newUser);
      modalInfoUser.value = false;
      userSelected.value = newUser;
    }
  }

  async function editUserOperation(
    name: string,
    username: string,
    role: string,
    emplid: string,
    base_price: string,
    password: string,
    email: string
  ) {
    const rol = await getRoleFromId(role);
    if (rol !== null) {
      const userUpdated = await editUser.execute(
        name,
        username,
        role,
        emplid,
        base_price,
        password,
        email,
        rol
      );
      const index = users.value.findIndex((user) => user.username === username);
      users.value = users.value.filter((user) => username !== user.username);
      users.value[index] = userUpdated;
      modalInfoUser.value = false;
    }
  }

  async function deleteUserOperation() {
    const userToDelete = userSelected.value;
    if (userToDelete !== null && userToDelete.username !== null) {
      await removeUser.execute(userToDelete.username);
      users.value = users.value.filter(
        (user) => userToDelete.username !== user.username
      );
    }
  }

  async function getRoleFromId(roleId: string): Promise<Role | null> {
    const roleOption = roles.value.find((rol) => rol.id === roleId) ?? null;
    return roleOption != null
      ? UserActions().createRole(roleOption.id, roleOption.esValue)
      : null;
  }

  return {
    createNewUser,
    modalInfoUser,
    closeInformationUserModal,
    users,
    userSelected,
    editUserSelected,
    createUserOperation,
    editUserOperation,
    deleteUserOperation,
    roles,
  };
}
